(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share')) {
    customElements.define(
      'product-share',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-share-button]');
          this.label = this.querySelector('[data-share-label]');
          this.status = this.querySelector('[data-share-status]');
          this.button?.addEventListener('click', () => this.share());
        }

        async share() {
          const shareData = { title: this.dataset.shareTitle, url: this.dataset.shareUrl };

          if (navigator.share) {
            try {
              await navigator.share(shareData);
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }

          try {
            await navigator.clipboard.writeText(shareData.url);
            this.showCopiedState();
          } catch {
            this.status.textContent = this.dataset.errorText;
          }
        }

        showCopiedState() {
          const copiedText = this.dataset.copiedText;
          this.label.textContent = copiedText;
          this.status.textContent = copiedText;
          window.clearTimeout(this.resetTimer);
          this.resetTimer = window.setTimeout(() => {
            this.label.textContent = this.label.dataset.defaultLabel;
            this.status.textContent = '';
          }, 2400);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
